import { AppBar, Button, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PowerSettingsNew } from '@material-ui/icons';
import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../store';



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    // appBarShift: {
    //     marginLeft: drawerWidth,
    //     width: `calc(100% - ${drawerWidth}px)`,
    //     transition: theme.transitions.create(['width', 'margin'], {
    //         easing: theme.transitions.easing.sharp,
    //         duration: theme.transitions.duration.enteringScreen,
    //     }),
    // },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    // drawerPaper: {
    //     position: 'relative',
    //     whiteSpace: 'nowrap',
    //     width: drawerWidth,
    //     transition: theme.transitions.create('width', {
    //         easing: theme.transitions.easing.sharp,
    //         duration: theme.transitions.duration.enteringScreen,
    //     }),
    // },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        backgroundColor: "#eaf8ff",
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    logoutButton: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    logoutIconButton: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 40,
            height: 40,
            border: '2px solid #f44336',
            borderRadius: 4,
            color: '#ffffff',
            backgroundColor: '#f44336',
        },
    },
}));

type AppShellProps = {
}

export const AppShell: FunctionComponent<AppShellProps> = ({ children }) => {
    const [profileMenuToggle, setProfileMenuToggle] = React.useState<{ toggle: boolean, target: any }>({ toggle: false, target: null });
    const [popupLogout, setPopupLogout] = React.useState<boolean>(false);

    const classes = useStyles();
    const store = useStore();
    const history = useHistory();

    const handlePopupLogoutClose = (value: any) => {
        console.log(value);
        setPopupLogout(false);
    }


    return (
        <>
            <CssBaseline />
            <AppBar position="fixed" color="primary">
                <Toolbar className={classes.toolbar}>
                    <Grid style={{ width: "100%" }} container xs={12} direction="row" justify="space-between" alignItems="center">
                        <Grid item xs={8}>
                            <Button onClick={() => history.push('/')} >
                                <Typography style={{ color: "white" }} variant="h6">
                                    Bhorosha (ভরসা)
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<PowerSettingsNew />}
                                onClick={() => setPopupLogout(true)} className={classes.logoutButton}
                            >Logout</Button>
                            <IconButton
                                onClick={() => setPopupLogout(true)} className={classes.logoutIconButton}>
                                <PowerSettingsNew />
                            </IconButton>
                            {/* <IconButton color="inherit" onClick={(event) => setProfileMenuToggle({ toggle: true, target: event.currentTarget })}>
                                <Avatar src="" />
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={profileMenuToggle.target}
                                keepMounted
                                open={profileMenuToggle.toggle}
                                onClose={() => setProfileMenuToggle({ toggle: false, target: null })}
                            >
                                <MenuItem>Profile</MenuItem>
                                <MenuItem>My account</MenuItem>
                                <MenuItem onClick={() => { setPopupLogout(true); setProfileMenuToggle({ toggle: false, target: null }); }}>Logout</MenuItem>
                            </Menu> */}

                            {/* Dialog for logout */}

                            <Dialog
                                open={popupLogout}
                                onClose={handlePopupLogoutClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Alert (সতর্কতা)"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Do you want to logout? (আপনি কি লগআউট করতে চান?)
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => { setPopupLogout(false) }} color="primary">
                                        No (না)
                                    </Button>
                                    <Button onClick={() => { store.auth.logout(); history.push('/login') }} color="primary" autoFocus>
                                        Yes (হ্যাঁ)
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        {children}
                    </Grid>
                </Container>
            </main>
        </>
    )
}